import { useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const HEARTBEAT_INTERVAL_MS = 25_000;

function getSessionId() {
  try {
    let id = sessionStorage.getItem('presence_sid');
    if (!id) {
      id = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      sessionStorage.setItem('presence_sid', id);
    }
    return id;
  } catch {
    return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
}

// Mounted once at the app root. Pings a lightweight presence endpoint so the
// Master Panel can show a live "aktive Nutzer" count. Not shown publicly.
export default function PresenceHeartbeat() {
  useEffect(() => {
    const sessionId = getSessionId();
    const send = () => {
      axios.post(`${API_URL}/api/presence/heartbeat`, { session_id: sessionId }).catch(() => {});
    };
    send();
    const id = setInterval(send, HEARTBEAT_INTERVAL_MS);
    return () => clearInterval(id);
  }, []);

  return null;
}
